import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/promotion'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(promotion, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, promotion, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  add(promotion) {
    return http.post(`${resource}`, promotion, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
